export default __webpack_public_path__ + "static/media/Pickpocket's Boots of the Final Way.7f19a76c.jpg";